// src/pages/User/CVSAList.js
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Container, Card, Button } from "react-bootstrap";
import Pagination from "../../components/Pagination";

const API_BASE = process.env.REACT_APP_API_BASE_URL;

const CVSAList = () => {
  const [records, setRecords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;

  const navigate = useNavigate();
  const { id: paramId } = useParams();

  const role = localStorage.getItem("userRole");
  const isAdmin = role === "1";
  const loggedInId = localStorage.getItem("userId");
  const userId = isAdmin && paramId ? paramId : loggedInId;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const headers = {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        };
        const res = await axios.get(`${API_BASE}/api/cvsa/${userId}`, {
          headers,
        });
        setRecords(res.data || []);
      } catch (err) {
        console.error("❌ Error fetching CVSA inspections", err);
      }
    };
    fetchData();
  }, [userId]);

  const paginatedRecords = records.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handleReturn = () => {
    if (isAdmin && paramId) navigate(`/userhome/${paramId}`);
    else navigate("/userhome");
  };

  return (
    <Container className="form-wrapper my-4">
      {/* 🔹 Header Section */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="mb-0">CVSA Inspections</h3>
        <div>
          <Button variant="secondary" className="me-2" onClick={handleReturn}>
            Return
          </Button>
          <Button
            variant="success"
            onClick={() => navigate(`/cvsa/${userId}/new`)}
          >
            Add
          </Button>
        </div>
      </div>

      {/* 🔹 Table Section */}
      <Card className="mt-3">
        <Card.Body>
          {records.length === 0 ? (
            <p className="mt-3 text-muted fst-italic text-center">
              No inspections found.
            </p>
          ) : (
            <div className="table-responsive mt-3">
              <table className="table table-bordered align-middle text-center">
                <thead className="table-light">
                  <tr>
                    <th className="text-center">Status</th>
                    <th className="text-center">Ready for Review</th>
                    <th className="text-center">Completion Date</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {paginatedRecords.map((r) => (
                    <tr key={r.cvsa_id}>
                      <td className="text-center">{r.cvsa_status || "-"}</td>
                      <td className="text-center">
                        {r.cvsa_ready_for_review ? "✔️" : "❌"}
                      </td>
                      <td className="text-center">
                        {r.ut_signdate
                          ? new Date(r.ut_signdate).toLocaleDateString()
                          : "-"}
                      </td>
                      <td className="text-center">
                        <Button
                          variant="warning"
                          size="sm"
                          onClick={() =>
                            navigate(`/cvsa/${userId}/detail/${r.cvsa_id}`)
                          }
                        >
                          ✎ Edit
                        </Button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>

              <Pagination
                currentPage={currentPage}
                totalItems={records.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
              />
            </div>
          )}
        </Card.Body>
      </Card>
    </Container>
  );
};

export default CVSAList;

